// Environment configuration
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5001/api',
  ENV: process.env.REACT_APP_ENV || 'development',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Procurement Dashboard'
};

// API endpoints
export const API_ENDPOINTS = {
  BASE_URL: config.API_BASE_URL,
  REQUESTS: `${config.API_BASE_URL}/requests`,
  REQUEST_DETAIL: (id: string) => `${config.API_BASE_URL}/requests/${id}`,
  PHASE1_REQUESTS: `${config.API_BASE_URL}/requests/phase1`,
  USERADMIN_REQUESTS: `${config.API_BASE_URL}/requests/useradmin`,
  APPROVE_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/approve`,
  REJECT_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/reject`,
  USERADMIN_APPROVE_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/useradmin-approve`,
  USERADMIN_REJECT_REQUEST: (id: string) => `${config.API_BASE_URL}/requests/${id}/useradmin-reject`,
  ANALYZE_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/analyze`,
  ANALYZE_REQUEST_MORE: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/analyze/more`,
  REVISION_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/revision`,
  UPDATE_REVISION: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-revision`,
  LOCAL_SUPPLIERS: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/local-suppliers`,
  REVISION_NOTIFICATIONS: `${config.API_BASE_URL}/requests/notifications/revisions`,
  UPDATE_REQUEST: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update`,
  SEND_SUPPLIER_EMAIL: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/send-email`,
  GET_EMAIL_TEMPLATE: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/email-template`,
  UPDATE_SUPPLIER_INFO: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/update-info`,
  ADD_SUPPLIER_TO_DATABASE: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/add-to-database`,
  ADD_SUPPLIER_WITH_PRODUCT: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/add-supplier-with-product`,
  ADD_OCR_TO_DATABASE: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/add-ocr-to-database`,
  MARK_EMAIL_RECEIVED: (request_id: string, supplier_index: string) => `${config.API_BASE_URL}/requests/${request_id}/supplier/${supplier_index}/mark-email-received`,
  SUPPLIER_SEARCH: `${config.API_BASE_URL}/suppliers/search`,
  ADD_PRODUCT_TO_SUPPLIER: (supplier_id: string) => `${config.API_BASE_URL}/supplier-products/supplier/${supplier_id}`,
  USERS: `${config.API_BASE_URL}/users`,
  USER_REGISTER: `${config.API_BASE_URL}/users/register`,
  FORGOT_PASSWORD: `${config.API_BASE_URL}/users/forgot-password`,
  RESET_PASSWORD: `${config.API_BASE_URL}/users/reset-password`,
  SUPPLIERS: `${config.API_BASE_URL}/suppliers`,
  OFFERS: `${config.API_BASE_URL}/offers`,
  // Supplier Products endpoints (replacing old company-products endpoints)
  SUPPLIER_PRODUCTS: (supplier_id: string) => `${config.API_BASE_URL}/supplier-products/supplier/${supplier_id}`,
  SUPPLIER_PRODUCTS_BULK_UPDATE: `${config.API_BASE_URL}/supplier-products/bulk-update`,
  UPLOAD_SUPPLIER_DOCUMENT: `${config.API_BASE_URL}/supplier-products/upload-document`,
  DOWNLOAD_SUPPLIER_DOCUMENT: (document_id: string) => `${config.API_BASE_URL}/supplier-products/download-document/${document_id}`,
  GET_SUPPLIER_PRODUCT_DOCUMENTS: (supplier_product_id: string) => `${config.API_BASE_URL}/supplier-products/${supplier_product_id}/documents`,
  // Companies endpoints (V2)
  COMPANIES: `${config.API_BASE_URL}/v2/companies`,
  COMPANY_NAME: (company_id: string) => `${config.API_BASE_URL}/v2/companies/${company_id}/name`,
  COMPANY_DETAILS: (company_id: string) => `${config.API_BASE_URL}/v2/companies/${company_id}`,
  COMPANY_USERS: (company_id: string) => `${config.API_BASE_URL}/v2/companies/${company_id}/users`,
  // Suppliers endpoints (V2)
  SUPPLIERS_V2: `${config.API_BASE_URL}/v2/suppliers`,
  SUPPLIER_DETAILS: (supplier_id: string) => `${config.API_BASE_URL}/v2/suppliers/${supplier_id}`,
  SUPPLIER_APPROVE: (supplier_id: string) => `${config.API_BASE_URL}/v2/suppliers/${supplier_id}/approve`,
  SUPPLIER_REJECT: (supplier_id: string) => `${config.API_BASE_URL}/v2/suppliers/${supplier_id}/reject`,
  SUPPLIER_RECOMMEND: (supplier_id: string) => `${config.API_BASE_URL}/v2/suppliers/${supplier_id}/recommend`,
  SUPPLIER_UNRECOMMEND: (supplier_id: string) => `${config.API_BASE_URL}/v2/suppliers/${supplier_id}/unrecommend`,
  SUPPLIER_NAME_SUGGEST: `${config.API_BASE_URL}/v2/suppliers/suggest-by-name`,
  // Products V2 endpoints
  PRODUCTS_V2: `${config.API_BASE_URL}/v2/products`,
  PRODUCTS_GROUPED: `${config.API_BASE_URL}/v2/products/grouped`,
  PRODUCT_VARIANTS: (variant_id: string) => `${config.API_BASE_URL}/v2/products/variants/${variant_id}`,
  PRODUCT_DETAILS: (product_id: string) => `${config.API_BASE_URL}/v2/products/${product_id}`,
  // Categories V2 endpoints
  CATEGORIES_V2: `${config.API_BASE_URL}/v2/categories`,
  CATEGORY_DETAILS: (category_id: string) => `${config.API_BASE_URL}/v2/categories/${category_id}`,
  // Requests V2 endpoints
  REQUESTS_V2: `${config.API_BASE_URL}/v2/requests`,
  REQUEST_V2_DETAIL: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}`,
  REQUEST_V2_PRODUCTS: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/products`,
  REQUEST_V2_MANUAL_PRODUCTS: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/products?is_manual=true`,
  REQUEST_PRODUCT_SIMILAR: (request_id: string, product_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/products/${product_id}/similar`,
  REQUEST_V2_MANUAL_PRODUCTS_ALL: `${config.API_BASE_URL}/v2/requests/manual`,
  REQUEST_COMMUNICATION_SUMMARY: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/communication/summary`,
  REQUEST_COMMUNICATION_MESSAGES: (request_id: string, supplier_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/communication/${supplier_id}/messages`,
  REQUEST_COMMUNICATION_AI_REPLY: (request_id: string, supplier_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/communication/${supplier_id}/reply-with-ai`,
  REQUEST_COMMUNICATION_ATTACHMENT: (request_id: string, attachment_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/communication/attachments/${attachment_id}`,
  REQUEST_QUOTES_SUMMARY: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/quotes-summary`,
  REQUEST_COMMUNICATION_SUPPLIER_PRODUCTS: (request_id: string, supplier_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/communication/${supplier_id}/supplier-products`,
  BRAVE_SUPPLIER_SEARCH: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/suppliers/brave-search`,
  BRAVE_SUPPLIER_SEARCH_PROGRESS: (request_id: string, request_product_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/suppliers/brave-search/progress/${request_product_id}`,
  REQUEST_PHASE_UPDATE: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/phase`,
  REQUEST_USER_SUPPLIERS: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/user-suppliers`,
  USER_NOTIFICATIONS: `${config.API_BASE_URL}/v2/requests/notifications/user`,
  USER_INBOX: `${config.API_BASE_URL}/v2/user-inbox`,
  USER_INBOX_ITEM: (inbox_id: string) => `${config.API_BASE_URL}/v2/user-inbox/${inbox_id}`,
  USER_INBOX_MESSAGE: (inbox_id: string) => `${config.API_BASE_URL}/v2/user-inbox/${inbox_id}/message`,
  USER_INBOX_UNREAD_COUNT: `${config.API_BASE_URL}/v2/user-inbox/unread-count`,
  USER_INBOX_ADD_PARTICIPANTS: (inbox_id: string) => `${config.API_BASE_URL}/v2/user-inbox/${inbox_id}/participants`,
  USER_INBOX_MARK_READ: `${config.API_BASE_URL}/v2/user-inbox/mark-read`,
  // RFQ Lock endpoints (concurrent access control)
  RFQ_LOCK: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/lock`,
  RFQ_LOCK_HEARTBEAT: (request_id: string) => `${config.API_BASE_URL}/v2/requests/${request_id}/lock/heartbeat`,
  // Pre-request (Cart) endpoints
  PREREQUESTS: `${config.API_BASE_URL}/v2/prerequests`,
  PREREQUEST_ADD: `${config.API_BASE_URL}/v2/prerequests/add`,
  PREREQUEST_UPDATE: `${config.API_BASE_URL}/v2/prerequests/update`,
  PREREQUEST_REMOVE: `${config.API_BASE_URL}/v2/prerequests/remove`,
  PREREQUEST_CLEAR: `${config.API_BASE_URL}/v2/prerequests/clear`,
  // Supplier Products V2 endpoints
  SUPPLIER_PRODUCTS_V2: `${config.API_BASE_URL}/v2/supplier-products`,
  SUPPLIER_PRODUCT_DETAIL: (supplier_product_id: string) => `${config.API_BASE_URL}/v2/supplier-products/${supplier_product_id}`,
  // Search endpoints (V2)
  SUPPLIER_SEARCH_V2: `${config.API_BASE_URL}/v2/search/suppliers`,
  PRODUCT_SEARCH_V2: `${config.API_BASE_URL}/v2/search/products`,
  UNIFIED_SEARCH: `${config.API_BASE_URL}/v2/search/unified`,
  // Issues endpoints
  ISSUES_REPORT: `${config.API_BASE_URL}/issues/report`,
  ISSUES_ADMIN_LIST: `${config.API_BASE_URL}/issues/admin/list`,
  // Export endpoints
  EXPORT_DATA: `${config.API_BASE_URL}/export/data`,
  EXPORT_FIELDS: (collection: string) => `${config.API_BASE_URL}/export/fields/${collection}`,
  // Analytics endpoints (V2)
  COMPANY_SAVINGS: (company_id: string) => `${config.API_BASE_URL}/v2/analytics/companies/${company_id}/savings`,
  COMPANY_TOTAL_SPEND_PIPELINE: (company_id: string) => `${config.API_BASE_URL}/v2/analytics/companies/${company_id}/total-spend-pipeline`,
  COMPANY_COMMITTED_SPEND: (company_id: string) => `${config.API_BASE_URL}/v2/analytics/companies/${company_id}/committed-spend`,
  COMPANY_YEARLY_OVERVIEW: (company_id: string) => `${config.API_BASE_URL}/v2/analytics/companies/${company_id}/yearly-overview`,
  // Debug endpoint removed (not available in V2)
  // COMPANY_REQUESTS_DEBUG: (company_id: string) => `${config.API_BASE_URL}/companies/${company_id}/requests-debug`,
  // Legacy endpoints (kept for compatibility but deprecated)
  PRODUCTS: `${config.API_BASE_URL}/products`,
  PRODUCT_SEARCH: `${config.API_BASE_URL}/products/search`,
  ADD_PRODUCT_TO_COMPANY: (company_id: string) => `${config.API_BASE_URL}/products/company/${company_id}/add`,
  // Email endpoints
  SENT_EMAILS: `${config.API_BASE_URL}/emails/sent`,
  EMAIL_HISTORY: (request_id: string, supplier_name: string) => `${config.API_BASE_URL}/emails/history/${request_id}/${supplier_name}`,
  SEND_REPLY: `${config.API_BASE_URL}/emails/send-reply`,
  INBOX: `${config.API_BASE_URL}/emails/inbox`,
  MAILBOX_FINISH: (mailbox_id: string) => `${config.API_BASE_URL}/emails/mailboxes/${mailbox_id}/finish`,
  MAILBOX_RECIPIENTS: (mailbox_id: string) => `${config.API_BASE_URL}/emails/mailboxes/${mailbox_id}/recipients`,
  AGENTIC_LOGS: `${config.API_BASE_URL}/agentic/logs`,
  REQUEST_AUDIT_LOGS: `${config.API_BASE_URL}/audit-logs/requests`,

  // Mailgun endpoints
  MAILGUN_SETUP_WEBHOOKS: `${config.API_BASE_URL}/mailgun/setup-webhooks`,
  MAILGUN_SEND_TEST_EMAIL: `${config.API_BASE_URL}/mailgun/send-test-email`,
  // Admin notifications endpoints
  ADMIN_NOTIFICATIONS: `${config.API_BASE_URL}/requests/notifications/admin`,
  // OCR endpoints
  OCR_PROCESS_UPLOAD: `${config.API_BASE_URL}/ocr/process-upload`,
  OCR_PROCESS_BASE64: `${config.API_BASE_URL}/ocr/process-base64`,
  OCR_UPLOAD_AND_PROCESS: `${config.API_BASE_URL}/ocr/upload-and-process`,
  OCR_LOGS: `${config.API_BASE_URL}/ocr/logs`,
  // Company addresses endpoints (V2)
  COMPANY_ADDRESSES: (company_id: string) => `${config.API_BASE_URL}/v2/addresses/companies/${company_id}/addresses`,
  COMPANY_ADDRESS: (company_id: string, address_id: string) => `${config.API_BASE_URL}/v2/addresses/companies/${company_id}/addresses/${address_id}`,
  COMPANY_ADDRESS_DEFAULT: (company_id: string, address_id: string) => `${config.API_BASE_URL}/v2/addresses/companies/${company_id}/addresses/${address_id}/set-default`,
  // PDF endpoints
  GENERATE_RFQ_PDF: (request_id: string) => `${config.API_BASE_URL}/pdf/rfq/${request_id}`,
  TEST_CORS: `${config.API_BASE_URL.replace('/api', '')}/test-cors`,
  // Edit endpoints
  UPDATE_SUPPLIER: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-supplier`,
  UPDATE_PRODUCT: (request_id: string) => `${config.API_BASE_URL}/requests/${request_id}/update-product`
};

// Development helpers
export const isDevelopment = config.ENV === 'development';
export const isProduction = config.ENV === 'production';

// Test CORS connection
export const testCorsConnection = async () => {
  try {
    const response = await fetch(API_ENDPOINTS.TEST_CORS);
    const data = await response.json();
    console.log('✅ CORS Test Success:', data);
    return true;
  } catch (error) {
    console.error('❌ CORS Test Failed:', error);
    return false;
  }
};

// Test CORS connection on startup in development
if (isDevelopment) {
  testCorsConnection();
} 